<template>
    <div class="autoAssign">
      <template>
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 表单 & 表格 -->
        <ots-table-group-new
          :selectList="selectList"
          :requestForm="requestForm"
          @search="search"
          :discript="discript"
          :tableHeader="tableHeader"
          :tableData="tableData"
        >
        </ots-table-group-new>
        <!-- 自动分配弹窗 -->
        <ots-custom-dialog :dialog.sync="DisDialog" title="自动分配" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form :model="autoDisForm" >
                <el-form-item label="考生范围">
                  <el-radio-group v-model="autoDisForm.range" class="ml-4">
                    <el-radio label="1" size="large">为已考考生分配</el-radio>
                    <el-radio label="2" size="large">为报考考生分配</el-radio>
                  </el-radio-group>
                </el-form-item> 
                <el-form-item label="课程">
                  <el-select v-model="autoDisForm.courseIds" placeholder="请选择">
                    <el-option v-for="(item, index) in courseData" :key="index" :label="item.courseName" :value="item.courseId"></el-option>
                  </el-select>
                </el-form-item> 
              </el-form>
              <p><span class="span-label">分配原则：</span>将<span class="col-red">未分配的考生</span>平均分配给评阅教师。</p>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="DisDialog = false">取消</el-button>
            <el-button round type="primary" @click="autoDisSet">确定</el-button>
          </template>
        </ots-custom-dialog>
      </template>
    </div>
</template>

<script>
import { getAutoReview, isAutoDis, importResult, autoLocationSet, delReAuto } from "@/http/modules/markPaper";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
export default {
  data(){
    return {
      // 标题按钮
      mainTopBtnList: [
        {
          title: "自动分配",
          fn: this.autoDis,
          plain: true,
        },
        {
          title: '导出',
          fn: this.exportReview
        }
      ],

      selectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: []
        }
      ],
      requestForm: {
        planId: "",
      },
      discript: {
        show: true,
        title: "“考场安排发布后”并且“成绩发布之前”才可分配评阅教师！",
      },
      tableHeader: [
        {
          title: "课程",
          prop: "courseName",
        },
        {
          title: "考试人数",
          prop: "examPeoples",
        },
        {
          title: "已考考生",
          type: 'stage',
          color: true,
          headerList: [
            {
              title: "已分配",
              prop: "examAssignPeoples"
            },
            {
              title: "已评阅",
              prop: "reviewPeoples"
            },
            {
              title: "未分配",
              prop: "examUnAssignPeoples",
              color: "red"
            }
          ]
        },
        {
          title: "未考考生",
          type: "stage",
          headerList: [
            {
              title: "已分配",
              prop: "unExamAssignPeoples"
            },
            {
              title: "未分配",
              prop: "unExamUnAssignPeoples"
            },
          ]
        },
        {
          title: "评阅教师",
          prop: "teacherName"
        },
        {
          title: "操作",
          type: "buttons",
          width: "165",
          fixed: "center",
          align: "center",
          headerAlign: "center",
          btnList: [
            {
              title: "删除分配",
              click: this.delAssignCourse,
            },
          ],
        },
      ],
      tableData: [],
      /* ** 自动分配 ** */
      DisDialog: false,
      autoDisForm: {
        courseIds: "",
        planId: "",
        range: "1",
      },
      courseData: [],
    }
  },
  watch: {
    "requestForm.planId" (val) {
      this.search();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    /************************
     * @this 初始化数据
     ************************/
    initData(){
      this.mixin_getSelectPlan().then( data => {
        this.selectList[0].data = data;
        this.requestForm.planId = data[0].id;
      })
    },

    /************************
     * @this 搜索
     ************************/
    search(){
      let params = { ...this.requestForm };
      getAutoReview(params).then(res => {
        if (res.code == 1) {
          this.tableData = res.data;
        }
        return isAutoDis(params);
      }).then(res => {
        if (res.code == 1) {
          this.discript.show = !res.data;
        }
      })
    },

    /************************
     * @this 删除分配
     ************************/
    delAssignCourse(row){
      if (row.delState == 1) {
        this.$confirm('确认删除该门课的评阅分配？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let params = {
            planId: this.requestForm.planId,
            courseId: row.courseId
          }
          delReAuto(params).then(res => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.search();
            }
          })
        }).catch(() => {        
        })        
      } else if (row.delState == 0) {
        this.$message.warning("“已评阅”或“成绩发布”后，不能再删除分配！");
      }
    },

    /************************
     * @this 自动分配按钮
     ************************/
    autoDis(){
      this.autoDisForm.courseIds = "";
      if (this.discript.show) {
        this.$message.warning("“考场安排发布后”并且“成绩发布之前”才可分配评阅教师！")
      } else {
        getPlanCourseFn({planId: this.requestForm.planId}).then(res => {
          if (res.code == 1) {
            this.courseData = [
              {
                courseId: "",
                courseName: "全部"
              },
              ...res.data
            ]
          }
        })
        this.DisDialog = true;
      }
    },
    
    /************************
     * @this 自动分配执行
     ************************/
    autoDisSet(){
      let params = { ...this.autoDisForm };
      params.planId = this.requestForm.planId;
      autoLocationSet(params).then(res => {
        if (res.code == 1) {
          this.DisDialog = false;
          this.search();
          this.$message.success(res.msg);
        } 
      })
    },

    /************************
     * @exportReveiw 导出
     ************************/
    exportReview(){
      let params = { ...this.requestForm };
      importResult(params).then(res => {
        if (res.code == 1) {
          window.location.href = res.data;
        }
      })
    },
  }
}

</script>


<style lang="less" scoped>
/deep/ .el-form-item {
  display: flex;
  height: 36px;
  .el-form-item__label {
    width: 80px;
    text-align: right;
    line-height: 36px;
  }
  .el-form-item__content {
    display: flex;
    align-items: center;
  }
  .el-radio {
    margin: 0;
    margin-right: 16px;
  }
}
.span-label {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.col-red {
  color: #FE5958;
}
</style>